import React, { useEffect } from "react";
import { Input, Button, Divider, Form, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { putApi } from "redux/sagas/putApiSaga";
import { SERVER_IP } from "assets/Config";
import { API_STATUS } from "constants/app-constants";
import { resetApiStatus } from "redux/reducers/globals/globalActions";
import { postApi } from "redux/sagas/postApiDataSaga";

const { TextArea } = Input;

const AddGPS = ({ handleClose, editGPS, setGPSAddModal }) => {
	const [form] = Form.useForm();
	const globalRedux = useSelector((state) => state?.globalRedux);
	const dispatch = useDispatch();

	const addGPS = (values) => {
		let data = {
			...values,
			gpsName: values.gpsName,
			imei: values.imei,
			sim: values.sim,
			model: values.model,
			remarks: values.remarks,
			orgId: globalRedux?.selectedOrganization?._id,
		};
		dispatch(postApi(data, "ADD_GPS"));
	};

	const handleEdit = (values) => {
		let data = {
			...values,
			orgId: globalRedux?.selectedOrganization?._id,
		};
		let url = `${SERVER_IP}gps/${editGPS._id}?orgId=${globalRedux?.selectedOrganization?._id}`;
		dispatch(putApi(data, "EDIT_GPS", url));
	};

	useEffect(() => {
		if (
			globalRedux.apiStatus.ADD_GPS === "SUCCESS" ||
			globalRedux.apiStatus.EDIT_GPS === "SUCCESS"
		) {
			dispatch(resetApiStatus(editGPS ? "EDIT_GPS" : "ADD_GPS"));
			setGPSAddModal(false);
			handleClose();
		}
	}, [globalRedux.apiStatus, editGPS, setGPSAddModal, handleClose, dispatch]);

	const layer1FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 12,
		},
	};

	const loading =
		globalRedux.apiStatus.ADD_GPS === API_STATUS.PENDING ||
		globalRedux.apiStatus.EDIT_GPS === API_STATUS.PENDING;

	return (
		<Row>
			<Col span={24}>
				{/* <Row style={{ backgroundColor: '#fff', padding: '10px 0px' }}>
					<Col>
						<h6 style={{ marginBottom: '0px' }}>{editGPS ? 'Edit' : 'New'} GPS</h6>
					</Col>
				</Row>
				<Divider /> */}
				<Row style={{ paddingTop: 0 }}>
					<Col span={24}>
						<Form
							name="add-gps"
							className="required_in_right"
							labelAlign="left"
							form={form}
							onFinish={!editGPS ? addGPS : handleEdit}
							{...layer1FormCol}
						>
							<Form.Item
								label="GPS Name"
								name="gpsName"
								initialValue={editGPS?.gpsName}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="GPS Name" />
							</Form.Item>
							<Form.Item
								label="IMEI"
								name="imei"
								initialValue={editGPS?.imei}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="imei" />
							</Form.Item>
							<Form.Item
								label="SIM"
								name="sim"
								initialValue={editGPS?.sim}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="sim" />
							</Form.Item>
							<Form.Item
								label="Model"
								name="model"
								initialValue={editGPS?.model}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="model" />
							</Form.Item>
							<Form.Item
								label="Remarks"
								name="remarks"
								initialValue={editGPS?.remarks}
							>
								<TextArea />
							</Form.Item>
							<Form.Item
								wrapperCol={{
									offset: 0,
									span: 24,
								}}
							>
								<Row justify="space-between">
									<Button
										onClick={() => setGPSAddModal(false)}
										style={{ width: "49%" }}
										danger
									>
										Cancel
									</Button>
									<Button
										loading={loading}
										type="primary"
										style={{ width: "49%", marginRight: 5 }}
										htmlType="submit"
									>
										{editGPS ? "Update" : "Create"}
									</Button>
								</Row>
							</Form.Item>
						</Form>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export default AddGPS;
